import { ResourceOptions } from 'react-admin';
import { FaTags } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.perpsV1Sectors;
export const icon = FaTags;
export const options: ResourceOptions = {
  label: 'resource.perpsV1Sectors',
};
